import React from 'react';

import {observer} from 'mobx-react';
import {Text} from "../../../../../../../core/components/misc/text/text";
import styles from "./../../../styles/game-center-header-status.module.scss";
import classNames from "classnames";
import {GameCenterHeaderModuleDetailsShortStatus} from "./game-center-header-module.details.short-status.";
import {GameCenterHeaderModuleDetailsAddedTime} from "./game-center-header-module.details.added-time";

export const GameCenterHeaderModuleDetailsStatusGameTime = observer(({controller}) => {
  const {state} = controller;
  const {
    showAnimationStatusText,
    statusTextAnimation,
    animation,
    displayStatusTextNearGameTime,
    displayStatusText,
    displayGameTime,
    addedTime
  } = state;

  const shouldRenderRectangle: Boolean = displayStatusText || displayGameTime
  const shouldRenderStatus: Boolean = animation || displayStatusTextNearGameTime || shouldRenderRectangle;

  const animationStatusTextProps = {
    text: showAnimationStatusText,
    className: classNames(statusTextAnimation, styles.animation_text),
  };

  return (
    shouldRenderStatus ? <div className={classNames(styles.status)}>
      {
        addedTime ? <div className={classNames(styles.added_time)}/> : null
      }
      {
        animation ? <Text {...animationStatusTextProps}/> :
          <GameCenterHeaderModuleDetailsShortStatus controller={controller}/>
      }
      <GameCenterHeaderModuleDetailsAddedTime controller={controller}/>
    </div> : null
  );
});
